<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import { api } from '@/api'
import { useToastStore } from '@/stores'

const route = useRoute()
const { $toast } = useToastStore()

const languageId = ref<any>('en')

const content = ref<any>({})
onMounted(async () => {
  const contentId = route.query.contentId
  if (route.query.currentLanguage)
    languageId.value = route.query.currentLanguage
  if (!contentId)
    return $toast('内容不存在')

  const { code, data, msg } = await api<any, any>({
    url: `/content/getContentDetail?contentId=${contentId}`,
    method: 'GET',
  })
  if (code !== 0)
    return $toast(msg)

  content.value = data
  // languageId.value = data.languageId || 'en'
  document.title = data.contentName
  // TODO: change download link w/ condition iOS/Android
})

const coverUrl = computed(() => {
  return content.value?.contentCoverUrl
})
const directUrl = import.meta.env.VITE_DIRECT_URL

const langList = ref([
  {
    leftText: 'ショートドラマ＆映画',
    rightBtnText: 'ダウンロード',
    value: 'ja',
  },
  {
    leftText: 'Short Dramas & Movies',
    rightBtnText: 'Download',
    value: 'en',
  },
])

function changeLang(lang: string) {
  return langList.value.find(item => item.value === lang)
}
</script>

<template>
  <div class="main">
    <!-- <nav class="truncate">
      {{ content?.contentName }}
    </nav> -->
    <div class="widget z-100">
      <img class="logo" src="@/assets/app-logo.png" alt="app-logo">
      <div>
        <p class="title">
          UniReel
        </p>
        <p class="subtitle">
          <span>{{ changeLang(languageId)?.leftText }}</span>
        </p>
      </div>
      <a class="button" :href="directUrl">
        <span>{{ changeLang(languageId)?.rightBtnText }}</span>
      </a>
    </div>

    <div v-if="coverUrl" class="cover relative" :style="`background: url(${coverUrl})`">
      <div style="height: 100%; background: #000; opacity: 0.7;" />
      <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; backdrop-filter: blur(8px);" />
      <img class="poster" :src="coverUrl" alt="poster">
      <div class="meta">
        <p class="title">
          {{ content?.contentName }}
        </p>
        <p class="description">
          {{ content?.introduce }}
        </p>
      </div>
    </div>
    <div class="bottom" :href="directUrl">
      <a :href="directUrl" class="button-gif">
        <img v-if="languageId === 'ja'" src="@/assets/icon-home-buttom.gif" alt="">
        <img v-if="languageId === 'en'" src="@/assets/icon-home-bottom-en.gif" alt="">
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  width: 100vw;
  max-width: var(--var-max-body-width, 750px);
  height: 100%;
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
  color: #fff;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}
nav {
  max-width: var(--var-max-body-width, 750px);
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  background: #000;
}
.widget {
  width: 100%;
  max-width: var(--var-max-body-width, 750px);
  height: 55px;
  padding: 7px 16px;
  background: #101010;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  .logo {
    width: 38px;
    height: 38px;
  }
  div {
    flex: 1;
    margin-left: 16px;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .subtitle {
    margin-top: 2px;
    font-size: 11px;
    color: #fff;
    opacity: 0.7;
  }
}

.cover {
  height: 100%;
  background-size: cover!important;
  background-position: top 0px left 50%!important;
  background-repeat: no-repeat!important;
  // z-index: -1;
}
.poster {
  width: 250px;
  height: 350px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 8px;
  position: absolute;
  top: 12%;
  left: 50%;
  transform: translateX(-50%);
}

.meta {
  position: absolute;
  top: calc(24% + 320px);
  width: 100%;
  padding: 0 16px;
  left: 50%;
  transform: translateX(-50%);
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .description {
    margin-top: 5px;
    font-size: 12px;
    line-height: 1.5em;
    opacity: 0.7;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

}
.bottom {
  position: fixed;
  bottom: 0px;
  padding-top: 16px;
  padding-bottom: 16px;
  width: 100%;
text-align: center;
width: 100%;
max-width: var(--var-max-body-width, 750px);
  .button-gif{
    width: 279px;
    height: 44px;
    width: 100%;
    max-width: var(--var-max-body-width, 750px);
    text-align: center;
    img {
      width: 100%;
    }
  }

}
.button {
  padding: 0 16px;
  height: 30px;
  line-height: 30px;
  background: linear-gradient(270deg, #FF3BDD 0%, #DF0050 100%), #EA046E;
  border-radius: 999px;
  display: block;
  text-align: center;
}
</style>
